import { createActionRecordAction } from "@buildwithflux/core";
export const toggleGlobalPcbRule = createActionRecordAction("toggleGlobalPcbRule", (ruleId, state, subRuleId) => {
    return {
        payload: {
            subRuleId,
            ruleId,
            state,
            canUndo: true,
            updatesDocumentTimestamp: true,
            shouldGenerateActionRecord: true,
        },
    };
}, "toggles a pcb layout rule");
//# sourceMappingURL=toggleGlobalPcbRule.js.map